import { HTMLAttributes } from 'react';
import styled from 'styled-components';

export const ModalContainer = styled.div<HTMLAttributes<HTMLDivElement>>`
  position: relative;
  padding: 32px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 432px;
  margin: 0 auto;
`;
